<template>
    <div>
        <h1 class="page-header">Test <small>demo</small></h1>

        <div class="row">
            <!-- begin col-6 -->


            <div class="col-lg-6">
                <!-- begin panel -->
                <panel title="Test" bodyClass="p-t-0">
                    <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :search-options="{ enabled: true, placeholder: 'Search this table' }"
                        :pagination-options="{ enabled: true,  position: 'bottom' }" :selectOptions="{
				enabled: true,
				selectOnCheckboxOnly: true,
				selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
				selectionText: 'rows selected',
				clearSelectionText: 'clear',
			}">
                        <div slot="selected-row-actions" style="margin: -2px 0;">
                            <button class="btn btn-xs btn-primary m-r-5">Action 1</button>
                            <button class="btn btn-xs btn-grey">Action 2</button>
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'image'">
                                <img v-bind:src="props.row.image" class="rounded" width="24" style="margin: -3px" />
                            </span>
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>
                </panel>
            </div>

            <div class="col-lg-6">
                <!-- begin panel -->
                <panel title="Test" bodyClass="p-t-0">
                    <doughnut-chart :data="doughnutChart.data" :options="doughnutChart.options" class="height-sm"></doughnut-chart>

                </panel>
            </div>

        </div>
    </div>
</template>
<script>
import DoughnutChart from "../../components/vue-chartjs/DoughnutChart";

export default {
  components: {
    DoughnutChart
  },
  data() {
    // eslint-disable-next-line
    Chart.defaults.global.defaultFontColor = "#2d353c";
    // eslint-disable-next-line
    Chart.defaults.global.defaultFontFamily =
      "Open Sans, Helvetica Neue,Helvetica,Arial,sans-serif";
    // eslint-disable-next-line
    Chart.defaults.global.defaultFontStyle = "600";

    return {
      doughnutChart: {
        data: {
          labels: ["Chrome", "Firefox", "Safari", "Opera", "IE"],
          datasets: [
            {
              backgroundColor: [
                "#5b6392",
                "#727cb6",
                "#8e96c5",
                "#348fe2",
                "#2a72b5"
              ],
              data: [35, 30, 15, 10, 5]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 70
        }
      },

      columns: [
        {
          label: "Name",
          field: "name",
          width: "15%",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        },
        {
          label: "Job",
          field: "job",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        },
        {
          label: "Age",
          field: "age",
          type: "number",
          width: "10%",
          tdClass: "text-center text-nowrap",
          thClass: "text-center text-nowrap"
        },
        {
          label: "Created On",
          field: "createdAt",
          type: "date",
          dateInputFormat: "YYYY-MM-DD",
          dateOutputFormat: "MMM Do YY",
          width: "10%",
          tdClass: "text-center text-nowrap",
          thClass: "text-center text-nowrap"
        },
        {
          label: "Percent",
          field: "score",
          type: "percentage",
          width: "10%",
          tdClass:
            "text-center f-s-14 f-w-600 text-inverse p-t-0 p-b-0 valign-middle text-nowrap",
          thClass: "text-center text-nowrap"
        }
      ],
      rows: [
        {
          id: 1,
          name: "John",
          job: "Frontend Developer",
          age: 20,
          createdAt: "2018-10-31",
          score: 0.036
        },
        {
          id: 2,
          name: "Jane",
          job: "Frontend Developer",
          age: 24,
          createdAt: "2018-10-31",
          score: 0.038
        },
        {
          id: 3,
          name: "Susan",
          job: "Android Developer",
          age: 16,
          createdAt: "2018-10-30",
          score: 0.031
        },
        {
          id: 4,
          name: "Chris",
          job: "iOS Developer",
          age: 55,
          createdAt: "2018-10-11",
          score: 0.033
        },
        {
          id: 5,
          name: "Dan",
          job: "Team Leader",
          age: 40,
          createdAt: "2018-10-21",
          score: 0.037
        },
        {
          id: 6,
          name: "Mollie",
          job: "Backend Developer",
          age: 20,
          createdAt: "2018-10-31",
          score: 0.032
        },
        {
          id: 7,
          name: "Bert",
          job: "Backend Developer",
          age: 23,
          createdAt: "2018-10-31",
          score: 0.029
        }
      ]
    };
  }
};
</script>
